export enum InventoryStatus {
	OK = 2,
	Excess = 4,
	Scarcity = 8,
	Stockout = 16,
	Rupture = 32,
}
